import env from '~/env';
import { isTruthy } from './predicate';

interface ScriptAttributes {
  src: string;
  async?: boolean;
  defer?: boolean;
  integrity?: string;
  crossOrigin?: string;
  referrerPolicy?: string;
}

function loadGTM() {
  const gtmId = env.APP_TAG_MANAGER_PROFILE;

  if (!gtmId) {
    // biome-ignore lint/suspicious/noConsole: We want this
    console.warn('GTM ID is missing. Skipping GTM script loading.');
    return;
  }

  if (!isTruthy(window.dataLayer)) {
    window.dataLayer = [];
  }

  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  loadScript({
    src: `https://www.googletagmanager.com/gtm.js?id=${gtmId}`,
    async: true,
  });
}

const loadScript = (attrs: ScriptAttributes) => {
  const script: HTMLScriptElement = document.createElement('script');
  script.type = 'text/javascript';

  for (const key in attrs) {
    if (Object.prototype.hasOwnProperty.call(attrs, key)) {
      if (key in script) {
        // @ts-expect-error: We've already checked that key is a valid property on script
        script[key] = attrs[key];
      } else {
        // biome-ignore lint/suspicious/noConsole: We want this
        console.warn(
          `The attribute ${key} is not a valid property of a script element`,
        );
      }
    }
  }

  document.head.appendChild(script);
};

export { loadGTM, loadScript };
